import { http } from './config';

const SOLARIMETRIC_DATA_PATH = 'solarimetricData';

export default {
  listar: () => http.get(`${SOLARIMETRIC_DATA_PATH}`)
};
